import { AccessScope, UpdateQuestionnaireInput } from 'src/graphql';
import { stripHtml } from 'src/utils/stripHtml';
import { LanguageOption } from 'src/utils/languages';

export function mapFormToUpdateQuestionnaireInput(
  title: string,
  description: string,
  categoryName: string,
  categoryId: number | null,
  selectedLanguages: LanguageOption[],
  autoReviewEnabled?: boolean,
  isSpeakUpForm?: boolean,
  countries?: Array<{ countryCode: string; countryName?: string }>,
  titleTranslations?: Record<string, string>,
  descriptionTranslations?: Record<string, string>,
): UpdateQuestionnaireInput {
  const trimmedDescription = description.trim();
  const plainText = stripHtml(trimmedDescription).trim();
  const finalDescription = plainText ? trimmedDescription : null;

  // Build translations array from non-default languages
  const translations = selectedLanguages
    .filter((lang) => lang.value !== 'en-GB') // Exclude default language
    .map((lang) => ({
      languageCode: lang.value,
      languageName: lang.label,
      publicTitle: titleTranslations?.[lang.value] || null,
      description: descriptionTranslations?.[lang.value] || null,
    }))
    .filter((t) => t.publicTitle || t.description); // Only include if has translation

  return {
    publicTitle: title,
    description: finalDescription,
    introduction: finalDescription,
    accessScope: AccessScope.Organization,
    targetDepartmentIds: undefined,
    category: categoryName,
    ...(categoryId != null ? { categoryId } : {}),
    languages:
      selectedLanguages.length > 0
        ? selectedLanguages.map((lang) => ({
            languageCode: lang.value,
            languageName: lang.label,
            isDefault: lang.value === 'en-GB',
          }))
        : undefined,
    ...(!isSpeakUpForm
      ? {
          autoReviewEnabled,
          ...(countries != null ? { countries } : {}),
        }
      : {}),
    ...(translations.length > 0 ? { translations } : {}),
  };
}
